export class ProductForm extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['submit']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  /**
   * @param {Event} e
   *
   * @returns {Promise<void>}
   */
  async onSubmitHandler (e) {
    e.preventDefault()

    await this.addToCart()
  }

  /**
   * @returns {Promise<Object>}
   */
  async addToCart () {
    return window.BAO.Cart.addItemFromForm(this.form)
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

if (!customElements.get('bao-product-form')) {
  customElements.define('bao-product-form', ProductForm)
}
